// socket.js
import { io } from "socket.io-client";

// const socket = io("http://localhost:5000");
const socket = io("https://api.astrogyata.in/", {
  transports: ["websocket"],
  autoConnect: true,
});
socket.on("connect", () => {
  console.log("Connected to server");
});
export default socket;
